import { ReactElement } from "react";


export const Space = (): ReactElement => {
	return <>{" "}</>;
};

Space.displayName = "Space";